import { REMOVE_USER_PHONE_REQUEST, REMOVE_USER_PHONE_SUCCESS, REMOVE_USER_PHONE_FAILURE } from '../../constants/user_phones.constants';

export const removeUserPhoneRequest = (phone_id, user_id) => ({ type: REMOVE_USER_PHONE_REQUEST, phone_id, user_id });
export const removeUserPhoneRequestSuccess = payload => ({ type: REMOVE_USER_PHONE_SUCCESS, payload });
export const removeUserPhoneRequestFailure = error => ({ type: REMOVE_USER_PHONE_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/actions/user_phones_actions/remove_user_phone.actions.js